module.exports = __webpack_public_path__ + "img/02.a1d21650.png";